import * as React from "react";
import { ChangeEvent } from "react";
import { Race, Driver } from "../../api/model";
import { getApi } from "../../api/ApiProvider";
import BranchSelector, { BranchData } from "../BranchSelector";
import { NotificationActions } from "../../store/notification/notification-actions";

// material
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextField } from "@material-ui/core";

export interface RaceDataComponentProps {
  race: Race;
  notificationActions: NotificationActions;
}

export interface RaceActionState {
  open: boolean;
  cancelationMsg: string;
  observation: string;
  driverSelected: number;
  driversList: Driver[];
  branchSelected: number;
  branchRace: number;
  branchList: BranchData[];
}

class RaceMiscActions extends React.Component<
  RaceDataComponentProps,
  RaceActionState
> {
  constructor(props: RaceDataComponentProps) {
    super(props);

    const drivers: Driver[] = [];
    const branches: BranchData[] = [];
    const driverRace = props.race.driver ? props.race.driver.id : 0;
    const branchRace = props.race.branch ? props.race.branch.id : 0;

    this.state = {
      open: false,
      observation: "",
      cancelationMsg: "",
      driverSelected: driverRace,
      driversList: drivers,
      branchSelected: 0,
      branchRace: branchRace,
      branchList: branches,
    };

    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDriverChangeEvent = this.handleDriverChangeEvent.bind(this);
    this.doAssign = this.doAssign.bind(this);

    getApi()
      .driver()
      .listActiveByAdmin()
      .then((data: Driver[]) => {
        const driversActive = data.filter(
          (d: any) => d.user.state === "ACTIVE"
        );
        this.setState({ driversList: driversActive });
      });

    getApi()
      .branch()
      .listAllBranchesAdmin()
      .then((data: BranchData[]) => {
        const indexBranch = data.findIndex(
          (d) => d.id === this.state.branchRace
        );
        this.setState({ branchSelected: indexBranch });
      });

    getApi()
      .branch()
      .listAllBranchesAdmin()
      .then((data: BranchData[]) => {
        this.setState({ branchList: data });
      });
  }

  handleClickOpen = () => {
    this.setOpen(true);
  };

  setOpen(st: any) {
    this.setState({ open: st });
  }

  handleClose = () => {
    this.setOpen(false);
    this.setState({ cancelationMsg: "" });
  };

  confirmCancelation = () => {
    if (confirm && this.state.observation !== "") {
      this.setOpen(false);
      getApi()
        .race()
        .cancel(this.props.race.id, this.state.observation)
        .then(
          (ok) => {
            console.log("==>cancelado", ok);
            this.props.notificationActions.addSuccess(
              "Cancelado",
              "Pedido cancelado correctamente",
              4000
            );

            window.location.reload();
          },
          (err) => {
            console.log("==>error cancelación", err);
            this.props.notificationActions.addError(
              "No procesado",
              "Hubo inconvenientes en la cancelación",
              4000
            );
          }
        );
    } else {
      return this.setState({ cancelationMsg: "No se agregó el motivo" });
    }
  };

  doAssign = () => {
    const driverId = this.state.driverSelected;
    getApi()
      .race()
      .assign(this.props.race.id, driverId)
      .then(
        (race) => {
          this.props.notificationActions.addSuccess(
            "Asignado",
            "Asignado a " + ((race.driver && race.driver.user.name) || ""),
            4000
          );
        },
        (err) => {
          console.log("==>error asignación", err);
          this.props.notificationActions.addError(
            "No procesado",
            "Hubo inconvenientes en la asignación",
            4000
          );
        }
      );
  };

  handleDriverChangeEvent(e: ChangeEvent<HTMLSelectElement>) {
    this.setState({
      driverSelected: +e.target.value,
    });
  }

  doChangeBranch = () => {
    const branchId = this.state.branchList[this.state.branchSelected].id;
    getApi()
      .race()
      .changeBranch(this.props.race.id, branchId)
      .then(
        (race) => {
          this.setState({
            cancelationMsg:
              "Sucursal Cambiada:" + ((race.branch && race.branch.name) || ""),
          });
        },
        (err) => {
          console.log("==>error cambio sucursal", err);
          this.setState({ cancelationMsg: "Error al cambiar de sucursal" });
        }
      );
  };

  render() {
    return (
      <>
        <div>
          <h4
            style={{
              textAlign: "center",
              fontWeight: "normal",
              marginBottom: -5,
            }}
          >
            Detalles del envío{" "}
          </h4>
          <hr />
          <div style={{ padding: 20, fontSize: 12 }}>
            Pedido:{" "}
            <strong>#{this.props.race.id.toString().toUpperCase()} </strong>
            <hr />
            Sucursal: &nbsp; {this.renderBranchSelector()}
            <Button
              variant="outlined"
              size="small"
              style={{ float: "right" }}
              onClick={this.doChangeBranch}
            >
              Cambiar{" "}
            </Button>
            <hr />
            Chofer: &nbsp; {this.renderAssing()}
            <Button
              style={{ float: "right" }}
              size="small"
              variant="outlined"
              onClick={this.doAssign}
            >
              Cambiar{" "}
            </Button>{" "}
            <hr />
            {this.props.race.state === "CANCELLED" ? (
              <>
                Estado: <strong>CANCELADO</strong>
                <hr />
                Motivo:{" "}
                <strong>{this.props.race.observation.toUpperCase()}</strong>
              </>
            ) : (
              <>
                <hr />
                <div style={{ textAlign: "center" }}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={this.handleClickOpen}
                  >
                    Cancelar pedido
                  </Button>
                </div>
              </>
            )}
            <hr />
          </div>
        </div>
        <Dialog
          maxWidth="sm"
          fullWidth={true}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="cancela-pedido-dialog-title"
          aria-describedby="cancela-pedido-dialog-description"
        >
          <DialogTitle id="cancela-pedido-dialog-title">
            {"Desea cancelar el pedido ?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="cancela-pedido-dialog-description">
              El pedido quedará en estado cancelado
            </DialogContentText>
            <DialogContentText id="cancela-pedido-dialog-description">
              <br />
              <br />
              <TextField
                type="text"
                label="Motivo de cancelación"
                placeholder="Agregar el motivo por el cual se cancela el pedido"
                InputLabelProps={{
                  shrink: true,
                }}
                style={{
                  width: "100%",
                }}
                multiline={true}
                value={this.state.observation}
                onChange={(e) =>
                  this.setState({
                    ...this.state,
                    observation: e.target.value,
                  })
                }
                margin="normal"
              ></TextField>
            </DialogContentText>
            {this.state.cancelationMsg !== "" &&
              this.state.observation === "" && (
                <DialogContentText id="cancela-pedido-dialog-description">
                  {this.state.cancelationMsg}
                </DialogContentText>
              )}
          </DialogContent>
          <DialogActions style={{ padding: 10 }}>
            <Button
              onClick={this.confirmCancelation}
              color="secondary"
              autoFocus
            >
              Si, cancelar
            </Button>
            <Button onClick={this.handleClose} color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  renderAssing() {
    return (
      <Select
        value={this.state.driverSelected}
        inputProps={{
          name: "assign-driver-selector",
          id: "driverAssingSelector",
        }}
        onChange={this.handleDriverChangeEvent}
      >
        {this.state.driversList
          ? this.state.driversList.map((driver, index) => (
              <MenuItem key={index} value={driver.id}>
                {driver.branch.name} / {driver.user.name}{" "}
              </MenuItem>
            ))
          : ""}
      </Select>
    );
  }

  renderBranchSelector() {
    return (
      <BranchSelector
        selected={this.state.branchSelected}
        branchList={this.state.branchList}
        onChange={(e) => {
          this.setState({ branchSelected: +e.target.value });
        }}
      />
    );
  }
}

export default RaceMiscActions;



// WEBPACK FOOTER //
// ./src/components/race/RaceMiscActions.tsx